var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"请选择品类"},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}},_vm._l((_vm.listNew),function(item){return _c('el-option',{key:item.categoryId,attrs:{"label":item.categoryName,"value":item.categoryId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }